import { Component, Input } from '@angular/core';
import { RouteLeg } from 'src/app/modules/route-planner/models/route-signposts-model';

@Component({
    selector: 'aa-aa-signpost-list',
    templateUrl: './aa-signpost-list.component.html',
    styleUrls: ['./aa-signpost-list.component.scss'],
    standalone: false
})
export class AaSignpostListComponent {

  @Input() direction: RouteLeg;

  constructor() { }

}
